import { render } from "./InputPref.vue?vue&type=template&id=c7d5d2ec&ts=true"
import script from "./InputPref.vue?vue&type=script&lang=ts"
export * from "./InputPref.vue?vue&type=script&lang=ts"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__